export enum EventType {
  Message = 'Message',
  Note = 'Note',
  SecureMessage = 'Secure Message',
  DirectMessage = 'Direct Message',
  HipaaConsent = 'HIPAA Consent',
  AppointmentReminder = 'Appointment Reminder',
  Assignment = 'Assignment',
  RhinopayConsent = 'Rhinpay Consent',
  SavedContent = 'Saved Content',
  MarketingConsent = 'Marketing Consent',
  VideoCall = 'Video Call',
  SavedContentSent = 'Saved Content Sent',
  PatientMerge = 'Merge Contact',
  CopyContent = 'Copy Content',
  Rhinoform = 'Rhinoform',
  ReminderNotification = 'Reminder Notification',
  AudioCall = 'Audio Call',
  PrescriptionReminder = 'Prescription Reminder',
  HipaaRequest = 'HIPAA Request',
  HipaaManualRequest = 'HIPAA Manual Request',
}
